import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7103458c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-full" }
const _hoisted_2 = { class: "hands-on-title w-full flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center text-white font-semibold" }, "待上机", -1))
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "people-list scrollBar w-full flex-1 text-white font-normal" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_JWaitCheck = _resolveComponent("JWaitCheck")!
  const _component_JWait = _resolveComponent("JWait")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_input, {
          value: _ctx.searchPeople,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchPeople) = $event)),
          "allow-clear": "",
          placeholder: "搜索员工姓名"
        }, {
          prefix: _withCtx(() => [
            _createVNode(_component_search_outlined, { class: "searchIcon" })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_collapse, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event)),
        "expand-icon-position": "right",
        bordered: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.plainOptions, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_collapse_panel, {
              key: index + 1
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
                }, [
                  (_ctx.onWorkBtn)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 0,
                        checked: item.checked,
                        "onUpdate:checked": ($event: any) => ((item.checked) = $event),
                        disabled: item.disabled,
                        onChange: _withModifiers(($event: any) => (_ctx.onCheckAllChange($event, index)), ["stop"]),
                        style: _normalizeStyle({marginRight: _ctx.$px2rem('20px'),})
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.teamName), 1)
                        ]),
                        _: 2
                      }, 1032, ["checked", "onUpdate:checked", "disabled", "onChange", "style"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.teamName), 1))
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.machineTeamUser, (t, v) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "already-people-item",
                    key: v
                  }, [
                    (_ctx.onWorkBtn)
                      ? (_openBlock(), _createBlock(_component_JWaitCheck, {
                          key: 0,
                          onWorkBtn: _ctx.onWorkBtn,
                          data: t,
                          onHandleChangeClick: _ctx.handleChangeClick
                        }, null, 8, ["onWorkBtn", "data", "onHandleChangeClick"]))
                      : (_openBlock(), _createBlock(_component_JWait, {
                          key: 1,
                          data: t
                        }, null, 8, ["data"]))
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey"])
    ])
  ]))
}